import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-ticket",
  templateUrl: "./med-icon-ticket.component.html",
})
export class MedIconTicketComponent extends SvgMixinComponent {}
